<div class="title">
  <app-breadcrumb [breadcrumbs]="breadcrumbs"></app-breadcrumb>
</div>
<button mat-icon-button mat-dialog-close test-id="dialog-close-button">
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content [class]="{ flex: data }">
  <mat-tab-group class="tabs-blue tabs-compact" [(selectedIndex)]="tabIndex" animationDuration="0ms" mat-stretch-tabs="false">
    <mat-tab label="{{ 'queriesDialog.tabLabels.auditTrail' | translate }}">
      <ng-template matTabContent>
        <ng-container *ngIf="!loading; else loadingState">
          <ng-container *ngIf="!empty; else emptyState">
            <table mat-table [dataSource]="auditTrailDataSource" multiTemplateDataRows>
              <ng-container matColumnDef="icon">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <mat-icon>
                    {{ auditTrailExpandedElement !== element ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
                  </mat-icon>
                </td>
              </ng-container>
              <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.value' | translate }}</th>
                <td mat-cell *matCellDef="let element"><span class="multi-line-wrap">{{ element.value }}</span></td>
              </ng-container>
              <ng-container matColumnDef="timestamp">
                <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.timestamp' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.created | date: 'MM/dd/yyyy HH:mm:ss' }}</td>
              </ng-container>
              <ng-container matColumnDef="operation">
                <th mat-header-cell *matHeaderCellDef>{{ 'queriesDialog.operation' | translate }}</th>
                <td mat-cell *matCellDef="let element">
                  <span #popoverContent>{{ element.operation }}</span>
                  <fw-popover [trigger]="popoverContent" position="above" action="mouseenter">
                    <div class="padding-15">
                      {{ 'queriesDialog.tooltips.' + (element.operation | lowercase) | translate }}
                    </div>
                  </fw-popover>
                </td>
              </ng-container>
              <ng-container matColumnDef="method">
                <th mat-header-cell *matHeaderCellDef>{{ 'queriesDialog.origin' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.method }}</td>
              </ng-container>
              <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.user' | translate }}</th>
                <td mat-cell *matCellDef="let element">{{ element.user }}</td>
              </ng-container>

              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
              <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="auditTrailVisibleColumns.length">
                  <div class="element-detail"
                    [@expandElement]="element === auditTrailExpandedElement ? 'expanded' : 'collapsed'">
                    <ul *ngIf="element.patchDetails.length">
                      <li>
                        <div class="name"><strong>{{ 'queriesDialog.name' | translate }}</strong></div>
                        <div class="value"><strong>{{ 'queriesDialog.value' | translate }}</strong></div>
                      </li>
                      <li *ngFor="let patch of element.patchDetails">
                        <div class="name action" (click)="viewAuditTrail(patch)">{{ patch.key }}</div>
                        <div class="value">{{ patch.value }}</div>
                      </li>
                    </ul>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="auditTrailVisibleColumns"></tr>
              <tr mat-row *matRowDef="let element; columns: auditTrailVisibleColumns" class="element-row"
                [class.expanded-row]="auditTrailExpandedElement === element"
                (click)="auditTrailExpandedElement = auditTrailExpandedElement === element ? null : element"></tr>

              <ng-container *ngIf="queryType === 'object'">
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
              </ng-container>
            </table>
          </ng-container>
        </ng-container>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<ng-template #loadingState>
  <div test-id="loading-state" class="blank-state content-body">
    <img src="/assets/images/loading.svg" style="margin-bottom:10px">
    <p>{{ 'common.labels.loading' | translate }}</p>
  </div>
</ng-template>

<ng-template #emptyState>
  <div class="blank-state">
    <mat-icon class="sm raised blue">list</mat-icon>
    <p>{{ 'queriesDialog.noData' | translate }}</p>
  </div>
</ng-template>
